export class functionpermission {
    agencycreate: boolean = true;
    agencydelete: boolean = true;
    agencyupdate: boolean = true;
}
export class fp{
    sendtobill:boolean=false;
}
export class sortingObj {
    itemperpage: number = 10;
    currentPgNo: number = 1;
    shortcolumn: string = "AgencyName";
    shortType: string = 'asc';
}
export class TimeSheetVerificationList {
    serialNo: number;
    timesheetId: string;
    agencyId: string | null;
    fromDate: string;
    toDate: string;
    totalHours: number;
    totalAmountBIlled: number;
    clientId: string;
    client_FirstName: string;
    client_LastName: string;
    client_MiddleName: string;
    client_Gender: string;
    client_DOB: string;
    client_Street: string;
    client_City: string;
    client_State: string;
    client_ZipCode: string;
    cLient_SSN: string;
    client_ServiceAgreementNo: string;
    client_InsuranceNo: string;
    clientAuthorizationId: string | null;
    employeeId: string;
    employee_FirstName: string;
    employee_MiddleName: string;
    employee_LastName: string;
    employee_UMPI: string;
    employeePayorUMPI: string;
    groupPayorId: string | null;
    payorName: string;
    payor_BillingFullName: string;
    payor_AddressLine1: string;
    payor_AddressLine2: string;
    payor_City: string;
    payor_State: string;
    payor_Zip: string;
    billingpayorID: string;
    i837PInsType: string;
    aTYPICAL: boolean | null;
    payor_PhoneNumber: string;
    groupPayorCompany_ProviderNo: string;
    claim_Filling_Ind: string;
    groupPayorCompany_CompanyFEIN: string;
    companyId: string | null;
    companyName: string;
    companyName_Billto_Name: string;
    companyName_Billto_Street: string;
    companyName_Billto_City: string;
    companyName_Billto_State: string;
    companyName_Billto_zipcode: string;
    companyName_Admin_FirstName: string;
    companyName_Phone: string;
    company_ProviderNo: string;
    groupPayorServiceId: number | null;
    billingUnit: number | null;
    netRate: number | null;
    unitrate: number | null;
    serviceLoc: string;
    renderingProviderCode: string;
    companyIdentifier: boolean | null;
    isIcd10FromClient: boolean | null;
    icd10: string;
    g2id: string;
    companyIdentifier_NPI: string;
    companyIdentifier_CompanyName: string;
    certificateICD10_01: string;
    certificateICD10_02: string;
    serviceCode: string;
    claimStatus: string;
    payDate: string | null;
    clientName: string;
    employee: string;
    bit: number;
    color: string;
    TimesheetId: string;
    error: Error[];
    lineItem: LineItem[];
    billingLovLid: string | null;
}
export class Error {
    columnName: string;
    isValid: boolean;
    serialno: string;
    color: string;
    colr: string;
    status: string;
    clientId: string;
    clientauthId: string;
    companyId: string;
    groupPayorId: string;
    grouppayorserviceId: string;
    certificateId: string;
    grouppayorServiceId: string;
    employeeId: string;
    payorName: string;
    supervisingEmployeeId:number;
}
export class LineItem {
    serviceId: number;
    serialNo: number;
    lineStatus: string;
    serviceDate: string;
    dailyHours: number;
    procedureCode: string;
    mOD1: string;
    mOD2: string;
    mOD3: string;
    billableHours: number;
    timeSheetId: number;
    timesheetNotes: string;
    employeeId: number;
    groupPayorServiceId: number | null;
    authorizationId: number | null;
    payableHours: number;
    over275Hrs: number;
    remaimimgAuthorizedHours: number | null;
    overDaily16Hours: number;
    service_Item_Charge_Amount: number;
    service_Unit_Quantity: number;
    paydate: string | null;
    bit: number;
    lineItemDetail: LineItemDetail[];
}
export class LineItemDetail {
    serviceId: number;
    lineStatus: string;
    timeSheetId: number;
    serviceDate: string;
    dailyHours: number;
    procedureCode: string;
    mOD1: string;
    mOD2: string;
    mOD3: string;
    over275Hrs: number;
    remaimimgAuthorizedHours: number | null;
    overDaily16Hours: number;
}
export class GetTimesheetVerificationBO {
    fromDate: string;
    toDate: string;
    orderColumn: string;
    orderType: string;
    pageitem: number;
    currentpageno: number;
    agencyId: number;
    conitionBO: WhereCondition[];
}
export class WhereCondition {
    field: string = "AgencyName";
    value: string = "";
    operator: string = "startswith";
    matchCase: boolean = false;
    orderNo: number = 1;
    predicate: string = "and";
    type: string = "string";
}
export class GetTimesheetverificationBO {
    fromDate: string;
    toDate: string;
    pageitem: number;
    currentpageno: number;
    agencyId: number;
    employee:string;
    client:string;
    field: string = "clientName";
    value: string = "";
    orderColumn: string = "clientName";
    orderType: string = "ASC";
    matchCase: boolean = false;
    operator: string = "startswith";
    type: string = "string";
    requesttype: string = "getdata"
    locationLid: string ;
    Claimid: string ="00000000-0000-0000-0000-000000000000";
    timesheetType:string;
    status:string|null;
    verificationGuid:string=null;
    timesheetId: number[] = [];
    isApproved:boolean|null
    isEvvApproved:boolean|null
    billingLovLid: number | null;
    isPaid:boolean=null;
}
export class ClientERRBOTSV {
    id: number;
    firstName: string;
    lastName: string;
    genderLid: number;
    gender: string;
    dOB: string;
    street: string;
    state: string;
    city: string;
    zipCode: string;
    serviceAgreementNo: string;
}
export class keyvalue {
    id: number = 0;
    key: string = '';
    value: string = '';
    Type: string = '';
    userId: string;
    agencyId: number;
}
export class claiminput {
    from: string = '';
    ids: number[] = [];
    start: string = '';
    end: string = '';
    claimId: string;
    errorValidation:boolean=false;
}
export class ClaimUpdateBO {
    claimMasterId: string;
    timesheetVerifications: TimeSheetVerificationList[];
}
